import { idle } from "./idle.js";
import { spinning } from "./spinning.js";
import { presentation } from "./presentation.js";
import { settings } from "./settings.js";
import { autoplaySettings } from "./autoplaySettings.js";
import { info } from "./info.js";
import { error } from "./error.js";
import { betSelect } from "./betSelect.js";

const actionHandlers = {
    settings,
    options: settings,
    autoplay: autoplaySettings,
    info,
    betSelect,
};

export async function slotLoop(scope, ctx) {
    const { gameLogic, hud } = ctx;

    scope.on(hud.onStopAutoplay, () => {
        if (ctx.autoplay) {
            hud.setAutoplayActive(false);
            ctx.autoplay = null;
        }
    });

    while (true) {
        let action;

        if (ctx.autoplay && ctx.autoplay.isActive() && gameLogic.canBet()) {
            action = "spin";
        } else {
            action = await scope.run(idle, ctx);
        }

        if (action === "spin") {
            await spinCycle(scope, ctx);

            if (ctx.autoplay) {
                ctx.autoplay.remaining = Math.max(0, ctx.autoplay.remaining - 1);
                hud.setAutoplayCount(ctx.autoplay.remaining);

                if (!ctx.autoplay.isActive()) {
                    hud.setAutoplayActive(false);
                    ctx.autoplay = null;
                }
            }
            continue;
        }

        const handler = actionHandlers[action];
        if (handler) await scope.run(handler, ctx);
    }
}

async function spinCycle(scope, ctx) {
    const { gameLogic } = ctx;

    if (!gameLogic.canBet()) return;

    try {
        const spinData = await scope.run(spinning, ctx);
        await scope.run(presentation, ctx, spinData);
    } catch (e) {
        if (e.code === "reject") return;
        await scope.run(error, ctx, e);
    }
}
